import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 发布 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 查看详情 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 参会名单 ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 结束 ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("~");

import { ref, computed } from 'vue';
import { dateFormat, getVexTableProps } from '@/config';
import { useStore } from 'vuex';
import { getAcademicList, delAcademic, publishAcademic, finishAcademic } from '@/request';
import { ElMessageBox, ElMessage } from 'element-plus';
import JoinNameListModal from './component/JoinNameListModal.vue';
export default {
  name: 'AcademicProject',

  setup(__props) {
    const store = useStore();
    const editShow = computed(() => store.state.user.userType == 3);
    const defaultForm = {
      scienceName: '',
      lecturer: '',
      startTime: '',
      endTime: '',
      status: '',
      scienceWay: ''
    };
    const selectedRow = ref({});
    const form = ref(_objectSpread({}, defaultForm));
    const table = ref();
    const showJoinNameListModal = ref(false);

    function reset() {
      form.value = _objectSpread({}, defaultForm);
      table.value.commitProxy('reload');
    }

    function del(row) {
      ElMessageBox.confirm('注意: 一旦删除不可恢复!', '确认删除?').then(() => {
        delAcademic({
          scienceId: row.scienceId,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function getJoinList(row) {
      selectedRow.value = row;
      showJoinNameListModal.value = true;
    }

    function publish(row) {
      ElMessageBox.confirm('注意: 一旦发布不可修改', '确认发布？').then(() => {
        publishAcademic({
          scienceId: row.scienceId,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function finish(row) {
      ElMessageBox.confirm('注意: 结束将停止数据收集', '确认结束？').then(() => {
        finishAcademic({
          scienceId: row.scienceId,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    const tableOptions = getVexTableProps({
      columns: [// {
      //   title: '项目编号',
      //   field: 'scienceId',
      //   width: '200px',
      //   showOverflow: true
      // },
      {
        title: '会议名称',
        field: 'scienceName',
        width: '200px',
        showOverflow: true
      }, {
        title: '讲师',
        field: 'lecturer',
        width: '150px',
        showOverflow: true
      }, {
        title: '会议时间',
        field: 'startTime',
        // width: '200px',
        showOverflow: true,
        slots: {
          default: 'time'
        }
      }, // {
      //   title: '项目结束时间',
      //   field: 'endTime',
      //   width: '200px',
      //   showOverflow: true
      // },
      {
        title: '开展方式',
        field: 'wayText',
        width: '150px',
        showOverflow: true
      }, {
        title: '开展地点/会议号',
        field: 'scienceAddress',
        width: '250px',
        showOverflow: true
      }, {
        title: '项目状态',
        field: 'statusText',
        width: '100px',
        showOverflow: true
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '350px',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getAcademicList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value)).then(data => {
              data.rows.forEach(i => {
                i.wayText = i.scienceWay === 1 ? '线上' : '线下';
                let statusObj = {
                  0: '未发布',
                  1: '已发布',
                  2: '已结束',
                  3: '推广中',
                  4: '未开始',
                  5: '进行中'
                };
                i.statusText = statusObj[i.status] || '未知';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        "label-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "会议名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.scienceName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.scienceName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "讲师"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.lecturer,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.lecturer = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.status = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "未发布",
                  value: "0"
                }), _createVNode(_component_el_option, {
                  label: "已发布",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "已结束",
                  value: "2"
                }), _createVNode(_component_el_option, {
                  label: "推广中",
                  value: "3"
                }), _createVNode(_component_el_option, {
                  label: "未开始",
                  value: "4"
                }), _createVNode(_component_el_option, {
                  label: "进行中",
                  value: "5"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开展方式"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.scienceWay,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.scienceWay = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "线上",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "线下",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[6] || (_cache[6] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_unref(editShow) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "Plus",
          onClick: _cache[7] || (_cache[7] = $event => _ctx.$router.push({
            name: 'EditAcademicProject',
            query: {
              from: _ctx.$route.name
            }
          }))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true)]),
        operation: _withCtx(({
          row
        }) => [_unref(editShow) && [0].includes(row.status) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          icon: "Delete",
          onClick: $event => del(row)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(editShow) && [0].includes(row.status) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "success",
          icon: "Promotion",
          onClick: $event => publish(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(editShow) && [0].includes(row.status) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          onClick: $event => _ctx.$router.push({
            name: 'EditAcademicProject',
            query: {
              scienceId: row.scienceId,
              from: _ctx.$route.name
            }
          }),
          icon: "Edit"
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), [1, 2, 3, 4, 5].includes(row.status) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          type: "primary",
          onClick: $event => _ctx.$router.push({
            name: 'EditAcademicProject',
            query: {
              scienceId: row.scienceId,
              from: _ctx.$route.name
            }
          }),
          icon: "View"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), [2, 3, 4, 5].includes(row.status) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          type: "warning",
          onClick: $event => getJoinList(row),
          icon: "Document"
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(editShow) && [5].includes(row.status) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 5,
          type: "danger",
          plain: "",
          onClick: $event => finish(row),
          icon: "Close"
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        time: _withCtx(({
          row
        }) => [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(row.startTime), 1), _hoisted_10, _createElementVNode("span", null, _toDisplayString(row.endTime), 1)])]),
        _: 1
      }, 16), _createVNode(JoinNameListModal, {
        scienceId: selectedRow.value.scienceId,
        modelValue: showJoinNameListModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showJoinNameListModal.value = $event)
      }, null, 8, ["scienceId", "modelValue"])]);
    };
  }

};